






























































import {
  Vue,
  Component,
  Prop,
  Watch,
} from "@/shared/vuepack";
import moment from "moment";
import Pagination from "@/shared/components/ui/Pagination.vue";
import { formatCurrency } from "@/shared/currency";
import { useUserStore } from "@/shared/store/user";
import { useEmployeeContributionHistoryStore } from "@/employer/store/employeeContributionHistory";

@Component({
  components: {
    Pagination
  }
})
export default class EmployeeContributionHistory extends Vue {
  userStore = useUserStore();
  employeeContributionHistoryStore = useEmployeeContributionHistoryStore();

  @Prop()
  employeeId: number;
  showTable = false;
  formatCurrency = formatCurrency;

  mounted () {
    this.loadEmployeeHistory(this.employeeContributionHistoryStore.historyPageNumber);
  }

  get payrollDescription () {
    return this.userStore.currentEmployerName + " " + "Payroll";
  }

  getFormattedDate (date): string {
    return moment(date).format("ll");
  }

  switchPage (toPage) {
    this.loadEmployeeHistory(toPage);
  }

  get isLoaded () {
    return this.employeeContributionHistoryStore.historyIsPageLoaded && this.showTable;
  }

  @Watch("employeeId")
  loadEmployeeHistory (page: number) {
    this.showTable = false;
    this.employeeContributionHistoryStore.getEmployeePlanYearContributions({
      id: this.employeeId,
      pageNumber: page,
      pageSize: this.employeeContributionHistoryStore.historyPageSize
    } as any)
      .then(() => {
        this.showTable = true;
      });
  }
}
